import CardComponent from "./CardComponent";

export class Description extends CardComponent {
}
